const personToMember = p => ({ gender: p.female ? 'female' : 'male', age: p.female || p.male });

export const prepareQuestionnaireData = data => {
  const people = data.peoples || {};
  const address = data.address || {};
  const adults = people.adults || {};
  const children = people.children || {};
  const proPlatform = data.pro_platform || false;
  return {
    family: {
      adults: Object.keys(adults).reduce(
        (acct, key, index) => ({ ...acct, [index]: personToMember(adults[key]) }),
        {},
      ),
      children: Object.keys(children).reduce(
        (acct, key, index) => ({ ...acct, [index]: personToMember(children[key]) }),
        {},
      ),
      pets: people.pets || {},
    },
    reasons: data.reasons || [],
    rooms: data.rooms || [],
    services: data.services || [],
    address,
    proPlatform,
  };
};

export const prepareQuestionnairePlanData = data => {
  const address = data.address || {
    address: {
      address: '',
      town: '',
      postcode: '',
      phone: '',
    },
  };
  const packages = Object.keys(data.packages || {}).reduce((acct, key) => {
    const rooms = Object.values(data.packages[key]).reduce(
      (a, item, index) => ({
        ...a,
        [`${key}_${index + 1}`]: item,
      }),
      {},
    );
    return {
      ...acct,
      ...rooms,
    };
  }, {});
  const roomsOptions = (data.rooms_options || []).reduce(
    (acct, option) => ({
      ...acct,
      [option.value]: option,
    }),
    {},
  );
  return {
    ...data,
    packages,
    address,
    roomsOptions,
  };
};



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/utils/data.js